import { useCallback, useState } from 'react';
import { getInstagramAudioStats, InstagramAudioStats } from '@round/api';

export default function useInstagramAudioStats(audioId: number) {
    const [stats, setStats] = useState<InstagramAudioStats | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const init = useCallback(
        async (requestInit?: RequestInit) => {
            if (!audioId) {
                return;
            }

            try {
                setIsLoading(true);
                setError(null);
                const response = await getInstagramAudioStats({ audioId }, requestInit);
                if (response.status === 404) {
                    setError(response.data.detail);
                    setIsInitialized(true);
                    return;
                }

                setStats(response.data);
                setIsInitialized(true);
            } catch (e) {
                if (e instanceof Error && e.name === 'AbortError') {
                    return;
                }

                setError(`Could not fetch instagram audio ${audioId} stats`);
                setIsInitialized(true);
            } finally {
                setIsLoading(false);
            }
        },
        [audioId]
    );

    return {
        stats,
        isLoading,
        isInitialized,
        error,
        init,
    };
}
